export default __webpack_public_path__ + "images/JG.82bf9bf.png";